import styled from "styled-components";

export const CartTotalStyled = styled.div`
  align-self: center;
  display: flex;
  flex-direction: column;

  width: 100%;
  max-width: 45.5rem;
  height: 12.2rem;

  gap: 1.6rem;
  padding: 0rem 2.2rem;

  & > div {
    display: flex;
    justify-content: space-between;
    align-items: center;

    margin-top: 1.4rem;

    & > span {
      font-size: 1.4rem;
      font-weight: 600;
    }
  }
`;
